// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"239":"7e8f9939","502":"4ce8d824","708":"2d301e88","711":"ef90e2da","841":"6b20e8fe","936":"49d93b3e"}[chunkId] + ".css";
};